import Request from './request'

export default class TaxCdsService {
  static async lookupMst(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/TaxCDSMstLookup/partner/lookupMst',
        data: data,
        token: false,
        headers: {
          apikey: process.env.REACT_APP_APIKEY
        }
      }).then((result = {}) => {
        const { statusCode, data, message, error } = result

        if (statusCode === 200) {
          return resolve({
            isSuccess: true,
            data,
            message,
            error: null
          })
        } else {
          return resolve({
            isSuccess: false,
            data: null,
            message,
            error
          })
        }
      })
    })
  }

  static async lookupTaxCode(data = {}) {
    return TaxCdsService.lookupMst(data)
  }

  static async lookupTaxObligation(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/TaxCDSObligationLookup/partner/lookupTaxObligation',
        data: data,
        token: false,
        headers: {
          apikey: process.env.REACT_APP_APIKEY
        }
      }).then((result = {}) => {
        const { statusCode, data, message, error } = result

        if (statusCode === 200) {
          return resolve({
            isSuccess: true,
            data,
            message,
            error: null
          })
        } else {
          return resolve({
            isSuccess: false,
            data: null,
            message,
            error
          })
        }
      })
    })
  }

  static async lookupHkdStatus(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/TaxCDSMstLookup/partner/lookupHkdStatus',
        data: data,
        token: false,
        headers: {
          apikey: process.env.REACT_APP_APIKEY
        }
      }).then((result = {}) => {
        const { statusCode, data, message, error } = result

        if (statusCode === 200) {
          return resolve({
            isSuccess: true,
            data,
            message,
            error: null
          })
        } else {
          return resolve({
            isSuccess: false,
            data: null,
            message,
            error
          })
        }
      })
    })
  }

  static async lookupTaxFinalization(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/TaxCDSFinalizationLookup/partner/lookupTaxFinalization',
        data: data,
        token: false,
        headers: {
          apikey: process.env.REACT_APP_APIKEY
        }
      }).then((result = {}) => {
        const { statusCode, data, message, error } = result

        if (statusCode === 200) {
          return resolve({
            isSuccess: true,
            data,
            message,
            error: null
          })
        } else {
          return resolve({
            isSuccess: false,
            data: null,
            message,
            error
          })
        }
      })
    })
  }

  static async lookupDeclarationStatus(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/TaxCDSDeclarationStatusLookup/partner/lookupDeclarationStatus',
        data: data,
        token: false,
        headers: {
          apikey: process.env.REACT_APP_APIKEY
        }
      }).then((result = {}) => {
        const { statusCode, data, message, error } = result

        if (statusCode === 200) {
          return resolve({
            isSuccess: true,
            data,
            message,
            error: null
          })
        } else {
          return resolve({
            isSuccess: false,
            data: null,
            message,
            error
          })
        }
      })
    })
  }

  static async lookupTaxRefund(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: '/TaxCDSRefundLookup/partner/lookupTaxRefund',
        data: data,
        token: false,
        headers: {
          apikey: process.env.REACT_APP_APIKEY
        }
      }).then((result = {}) => {
        const { statusCode, data, message, error } = result

        if (statusCode === 200) {
          return resolve({
            isSuccess: true,
            data,
            message,
            error: null
          })
        } else {
          return resolve({
            isSuccess: false,
            data: null,
            message,
            error
          })
        }
      })
    })
  }
}